import React, { useEffect } from 'react'
import { StatusPane } from '@pff-consumer/tweed-ui/molecules/status-pane/status-pane.web'
import { CurrentProgressState } from '@pff-consumer/schema'
import { useRouter } from 'next/router'
import { useStyles } from './create-account-error.styles'
import { CreateAccountErrorProps } from './create-account-error.props'

export const CreateAccountError = ({ error, onClick }: CreateAccountErrorProps) => {
  const router = useRouter()
  const styles = useStyles()

  useEffect(() => {
    router.push({ query: { success: false, message: error } }, undefined, { shallow: true })
  }, [])

  return (
    <div className={styles.createAccountContainer}>
      <StatusPane
        state={CurrentProgressState.ERROR}
        header='Account Creation Failed'
        message={`We went for it on 4th and missed. Let's get another drive going and try again!`}
        actionText='TRY AGAIN'
        onAction={onClick}
      />
    </div>
  )
}
